export { default } from './Pactometre';
